export default __webpack_public_path__ + "static/media/Square-White-Logo-with-Cloured-Background.d25126a0.svg";